<ng-content select="[pre-title]"></ng-content>

@if (title) {
<ng-container class="relative">
  <h2 class="w500 marBot20 tAlignLeft">{{ title }}</h2>
  @if (subtitle) {
  <p class="w300 darkGreyT tAlignLeft">{{ subtitle }}</p>
  }
  <ng-content select="[post-title]"></ng-content>
</ng-container>
}

<div class="dFlex justifyContentFlexEnd modalCloseContainer closeX">
  <button matDialogClose aria-label="Close modal" type="button">
    <fa-icon [icon]="['fas', 'xmark']"></fa-icon>
  </button>
</div>

<ng-content></ng-content>
